<template>
  <div>
    <van-row >
      <van-col :span="22" :offset="1" class="title f-s-10 gray-3">
        BIM精品课
        <!-- <span class="f-l-r lookMore" @click="lookMoreClass">查看更多 ></span> -->
      </van-col>
      <!-- 列表循环开始 -->
      <van-row v-if="classList.length > 0">
        <van-col
          :span="22"
          v-for="(item, index) in classList"
          @click="selectCourse(item)"
          :key="index"
          :offset="1"
          class="bg-white classStyle"
          style="margin-bottom:0.75rem;border-radius: 0.3rem;"
        >
          <van-row>
            <van-col :span="24">
              <div class="van-multi-ellipsis--l2" style="font-size:0.85rem;font-weight: 500;">
                <van-tag
                  color="#858E9B"
                  text-color="#FFFFFF"
                  style="line-height:0.9rem;font-size:0.5rem"
                  v-if="item.course.itname != '' && item.course.itname != null"
                  >{{ item.course.itname }}</van-tag
                >
                <!-- <span style="font-size:0.85rem;font-weight: 500;"> -->
                  {{ item.course.courseTitle }}
                <!-- </span> -->
              </div>
            </van-col>
            <van-col :span="24">
              <span style="font-size: 0.65rem;color: #657081;"
                >{{ item.course.startTime }} 至 {{ item.course.endTime }} |
                {{ item.course.ccount }}课时</span
              >
            </van-col>
          </van-row>
          <van-row style="margin-top:0.8rem">
            <van-col :span="17">
              <div
                style="width:2.1rem;line-height:0.9rem;min-width:36px"
                class="f-l-l m-r-02 text-c"
                v-for="(tea, i) in item.course.tlist"
                :key="i"
              >
                <van-image round width="1.6rem" height="1.6rem" :src="tea.turl" />
                <p class="text-c m-t-3 ft10" style="font-size: 0.5rem;color: #657081;">
                  {{ tea.tname }}
                </p>
              </div>
            </van-col>
            <van-col :span="7" class="f-l-r text-r">
              <span class="color-oringer" style="font-size:0.6rem">¥</span>
              <span class="color-oringer" style="font-size: 1.2rem;">{{
                item.course.coursePrice
              }}</span>
              <p style="font-size: 0.5rem;color: #657081;" class="m-t-3">{{item.course.courseXnum}}人已购买</p>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </van-row>
    <!-- <van-empty image="error" description="暂无更多BIM精品课" v-if="classList.length <= 0" /> -->
  </div>
</template>

<script>
export default {
  props: {
    classList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    selectCourse(item) {
      this.$router.push({
        path: "/details",
        query: {
          cid: item.course.cid,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  height: 0.9rem;
  line-height: 0.9rem;
  margin-bottom: 0.75rem;
}
.lookMore {
  font-size: 0.6rem;
  color: #657081;
}
.classStyle {
  padding: 0.75rem 1rem 0.8rem 1rem;
}
.color-oringer {
  color: #f07f5a;
}
</style>
